var map = {
	"./Character.png": 124,
	"./Fundo.png": 252,
	"./Garota.png": 253,
	"./Garoto.png": 254,
	"./Logo - Teste.png": 255,
	"./Logo - Teste_2.png": 256,
	"./Logo - Transparente.png": 257,
	"./Logo.png": 258,
	"./Professora.png": 259,
	"./Vector.png": 143,
	"./Vector_2 - Copy.png": 260,
	"./Vector_2.png": 100,
	"./Vector_3.png": 126,
	"./Vector_4.png": 261,
	"./Vector_5.png": 262,
	"./Vector_6.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;